import React from 'react'
import PromoGrid from '.'
import { SimpleBlockWrapper } from '../../../utils/blocks'

interface PromosGridWidgetProps {
  listId: string
}

const PromosGridWidget = ({ listId }: PromosGridWidgetProps) => {
  return (
    <SimpleBlockWrapper>
      <PromoGrid listId={listId} />
    </SimpleBlockWrapper>
  )
}

export default PromosGridWidget
